import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog", "image", "caption"];

  connect() {
    this.onKeydown = this.onKeydown.bind(this);
  }

  disconnect() {
    this.unlock();
    window.removeEventListener("keydown", this.onKeydown);
  }

  open(event) {
    event?.stopPropagation?.();
    const { url, caption } = event.currentTarget.dataset;
    this.imageTarget.src = (url || "").replace("w=900&h=500", "w=1400&h=800");
    this.imageTarget.alt = caption || "";
    if (this.hasCaptionTarget) {
      this.captionTarget.textContent = caption || "";
      this.captionTarget.classList.toggle("hidden", !caption);
    }
    this.dialogTarget.classList.remove("hidden");
    this.dialogTarget.classList.add("flex");
    this.lock();
    window.addEventListener("keydown", this.onKeydown);
  }

  close(event) {
    event?.stopPropagation?.();
    this.dialogTarget.classList.add("hidden");
    this.dialogTarget.classList.remove("flex");
    this.unlock();
    window.removeEventListener("keydown", this.onKeydown);
  }

  stop(event) {
    event.stopPropagation();
  }

  key(event) {
    this.onKeydown(event);
  }

  onKeydown(event) {
    if (this.dialogTarget.classList.contains("hidden")) return;
    if (event.key === "Escape") this.close();
  }

  lock() {
    document.body.style.overflow = "hidden";
  }

  unlock() {
    document.body.style.overflow = "";
  }
}
